_ = require 'underscore'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
PluginView = require 'app/scripts/views/plugin/plugin-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'

module.exports = class PluginButtonView extends PluginView
  tagName: ->
    if @options.pluginButton.url? then 'a' else 'span'

  attributes: ->
    { url, target } = @options.pluginButton
    if url && pluginValidators.isValidUrlForIframe(url)
      href: url
      target: target ? url
      rel: 'noreferrer nofollow noopener'

  initialize: ({ @pluginButton }) ->
    @retain(@pluginButton)

  events:
    'click': (e) ->
      Util.stopPropagation(e)
      @trackClick?(@pluginButton)
      if @pluginButton.callback?
        # find the correct anchor for potential popup
        el = e.target.closest('.button-link') ||
          e.target.closest('.board-header-btn') ||
          e.target.closest('a') ||
          e.target
        if @isPopOverShowing(el)
          PopOver.hide()
        else
          @pluginButton.callback
            el: el
          .done()

  template: ->
    throw Error('no template specified')

  isPopOverShowing: (el) ->
    return PopOver.contains(el) || PopOver.toggledBy(el)

  renderOnce: ->
    @$el.html(@template(@pluginButton))
    @
